import { Moment } from "moment";

export enum DateFormatWithSlashEnum {
  'Day_Month_Year' = 'DD/MM/YYYY',
  'Year_Month_Day' = 'YYYY/MM/DD',
}

export const formatDateWithSlash = (date: Moment, type: DateFormatWithSlashEnum):string => {
  let day = date.date().toString().padStart(2, '0');
  let month = (date.month() + 1).toString().padStart(2, '0');
  let year = date.year().toString();

  if(type === DateFormatWithSlashEnum.Day_Month_Year){
    return `${day}/${month}/${year}`
  } else if (type === DateFormatWithSlashEnum.Year_Month_Day){
    return `${year}/${month}/${day}`
  }

  return 'Proporcione un formato de fecha';
}
